<template>
  <el-container class="main-content">
    <el-main>
      <!-- <van-card :num="product_num" :price="this.$Shared.formatPrice(price)" :desc="desc" :title="product_name"
          :thumb="image" /> -->
      <div style="width: 600px; margin: 40px auto;">
        <div style="font-size: 24px">选择支付方式</div>
        <el-row style="margin-top:30px;" :gutter="20">
          <el-col :span="12" class="method alipay" :class="payMode === 2 ? 'active' : ''">
            <div class="method-inner" @click="onSelectPayMode(2)">
              <a style="display: block;">
                <img :src="require('~/assets/images/alipay.png')" alt="支付宝" title="支付宝">
                <div class="selected-symbol">
                  <i class="el-icon-circle-check"></i>
                </div>
              </a>
            </div>
          </el-col>
          <el-col :span="12" class="method wechat" :class="payMode === 1 ? 'active' : ''">
            <div class="method-inner" @click="onSelectPayMode(1)">
              <a style="display: block;">
                <img :src="require('~/assets/images/weixinPay.png')" alt="微信支付" title="微信支付">
                <div class="selected-symbol">
                  <i class="el-icon-circle-check"></i>
                </div>
              </a></div>
          </el-col>
        </el-row>
      </div>

      <div style="clear: both; margin-top: 60px;">
        <el-button type="danger" style="width: 300px;" @click="onPay">{{btnPayText}}</el-button>
      </div>

      <form id='alipaysubmit' name='alipaysubmit' style="display:none" :action='actionUrl' method='POST'>
        <input name="apiBasePath" type="text" :value="$apiBasePath">
        <input name="token" type="text" :value="token">
        <input name="plan_id" type="text" :value="planId">
        <input name="part_id" type="text" :value="partId">
        <input name="pay_mode" type="text" value="2">
      </form>
    </el-main>
    <el-dialog title="请用微信扫描二维码并支付" :visible.sync="weixinQrVisible" width="50%">
      <div>
        <img :src="weixinQrPath" />
        <p>支付完成请关闭本页面，支付出现有问题请联系求职顾问。</p>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="weixinQrVisible = false">取 消</el-button>
        <el-button type="primary" @click="weixinQrVisible = false">确 定</el-button>
      </span>
    </el-dialog>
  </el-container>
</template>

<script>
  import {
    payOrder,
    checkPaidState
  } from '~/api/mall.js';

  export default {
    data() {
      return {
        planId: this.$route.query.planId,
        partId: 0,
        payMode: 2,
        btnPayText: '立即支付',
        actionUrl: this.$webSite + '/MyPay/Alipay_Confirm',
        token: this.$store.getters.token,
        weixinQrVisible: false,
        weixinQrPath: '',
        checkPayStateIntervel: 0,
      };
    },
    watch: {
      payMode(val) {
        if (val === 1) {
          this.btnPayText = '微信支付';
        } else if (val === 2) {
          this.btnPayText = '支付宝支付';
        }
      }
    },
    methods: {
      onSelectPayMode(val) {
        this.payMode = val;
      },
      onPay() {
        var orderData = {
          plan_id: this.planId,
          part_id: this.partId,
          pay_mode: this.payMode
        };
        payOrder(orderData).then(m => {
          if (m.errcode === 0) {
            if (this.payMode === 2) {
              var dataDom = m.data;
              const div = document.createElement('div');
              div.innerHTML = dataDom;
              document.body.appendChild(div);
              document.forms.alipaysubmit.submit();
            } else if (this.payMode === 1) {
              this.weixinQrVisible = true;
              this.weixinQrPath = m.data;
              this.checkPayStateIntervel = setInterval(this.checkOrderPlanState, 1000);
            }
          }
        });
      },
      checkOrderPlanState() {
        var params = {
          plan_id: this.planId
        };
        checkPaidState(params).then(m => {
          if (m.errcode === 0) {
            this.$message.success('支付已完成，工作人员会尽快与您联系，请务必保持电话畅通。');
            if(this.checkPayStateIntervel){
              clearInterval(this.checkPayStateIntervel);
            }
            setTimeout(() => {
              this.$router.push({
                path: '/ProfessionalResume',
                query: {
                  id: 1
                }
              });
            }, 500);
          }
        });
      }
    }
  };
</script>

<style>

</style>